import { sellerSortOrders } from '@/enums';

const filterFavoriteSortOptions = (sortOptions: string[]) => {
    return sortOptions.filter((sortType) => sortType !== sellerSortOrders.UPCOMING_LOWEST_FIRST);
};

export default filterFavoriteSortOptions;
